import { faPaperclip } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useState } from "react";
import axios from "../../../config/axiosConfig";
import { Alert, Snackbar } from "@mui/material";
import CircularProgress from "@mui/material/CircularProgress";
import { useNavigate } from "react-router-dom";
const CreatePost = () => {
  const [openSnackbar, setOpenSnackbar] = React.useState(false);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const handleCreatePost = async () => {
    setLoading(true);
    try {
      const response = await axios.post("/post", {
        caption,
        image: base64Image,
      });
      if (response.data.status === "success") {
        navigate("/home");
      }
    } catch (error) {
      if (error?.response?.status === 413) {
        setOpenSnackbar(true);
      }
      console.log(error);
    }
    setLoading(false);
  };
  const [base64Image, setBase64Image] = useState();
  const [caption, setCaption] = useState("");
  const handleImageUpload = (event) => {
    const file = event.target.files[0];

    if (file) {
      const reader = new FileReader();

      reader.onload = function (e) {
        const base64String = e.target.result;
        setBase64Image(base64String);
      };

      reader.readAsDataURL(file);
    }
  };

  return (
    <div className="h-screen m-6 mt-8 flex flex-col">
      <div className="flex flex-row justify-between items-center">
        <button
          onClick={() => {
            window.history.back();
          }}
        >
          Cancel
        </button>
        <p className="font-bold">New Post</p>
        <button
          className="bg-[#0095F6] text-white px-5 py-[0.55rem] rounded-[1000px] text-xs"
          onClick={handleCreatePost}
        >
          {loading ? (
            <CircularProgress color="inherit" size={13} className="mx-2" />
          ) : (
            "Post"
          )}
        </button>
      </div>

      <div className="flex flex-col mt-10">
        <textarea
          type="text"
          placeholder="What do you want to sell?"
          className="focus:outline-0"
          cols={40}
          onChange={(e) => {
            setCaption(e.target.value);
          }}
        ></textarea>
        <label className="mt-10">
          <FontAwesomeIcon icon={faPaperclip} className="w-[1.5rem]" />
          <input
            type="file"
            id="imageInput"
            className="hidden"
            accept="image/*"
            multiple
            onChange={handleImageUpload}
          />
        </label>

        <div id="output" className="mt-10 flex flex-row">
          {base64Image && (
            <img
              src={base64Image}
              alt={`Uploaded`}
              style={{ width: "100px", height: "100px" }}
            />
          )}
        </div>
      </div>
      <Snackbar
        open={openSnackbar}
        autoHideDuration={3000}
        onClose={() => {
          setOpenSnackbar(false);
        }}
      >
        <Alert
          severity="error"
          onClose={() => {
            setOpenSnackbar(false);
          }}
          sx={{ width: "100%" }}
        >
          Your image is too large
        </Alert>
      </Snackbar>
    </div>
  );
};

export default CreatePost;
